// DS: i2.5
import React from 'react';
import IconWrap from '../../IconWrap';
const Stacked = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M18 11.002a1 1 0 011 1v8a1 1 0 01-1 1H6a1 1 0 01-1-1v-8a1 1 0 011-1h12zm-2-4a1 1 0 010 2H8a1 1 0 110-2h8zM14 3a1 1 0 01.993.883l.007.119a1 1 0 01-1 1h-4a1 1 0 01-.993-.883L9 4a1 1 0 011-1h4z"
    })));
Stacked.displayName = 'Stacked';
export default Stacked;
